export default __webpack_public_path__ + "static/media/thanks_round_1.07b6d75a.gif";